

  import axios from 'axios';
  import { Component, Vue } from 'vue-property-decorator'
  import { getCurrentInstance } from 'vue';
  import {authService} from '../../olsStateManagement/services/auth.service'
  import AutoSignOut from '../components/AutoSignOut.vue'
  import BrowserDetector from '../../olsStateManagement/helpers/browserDetector'
  import {DEFAULT_ROOT_URL, DEFAULT_ROOT_URL_FR} from '../../olsStateManagement/helpers/constants'
  import "../helpers/helpers";

  const browserDetector = new BrowserDetector();
  // const authService = new AuthService();

  @Component({
    components: {
      "auto-signout": AutoSignOut
    }
  })

  export default class App extends Vue {

    public currentOlsUser: any = {}
    public clientData: any = {}
    public shoppingCartData: any = {}
    public authLabels: any = {}
    public userName: string = ""

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;

    public isVisible: boolean = false;

    public loader: any = {
      loaded: false,
      loading: false
    }

    public sessionExpiredDialog: any = {
      isOpen: false,
    }

    public olsUserNotActiveDialog: any = {
      isOpen: false,
    }

    // on these pages redirection should NOT work!!!
    public doNotRedirectUrls = [
                            DEFAULT_ROOT_URL,
                            DEFAULT_ROOT_URL + 'en',
                            DEFAULT_ROOT_URL + 'en/user/login',
                            DEFAULT_ROOT_URL + 'fr',
                            DEFAULT_ROOT_URL + 'fr/user/login',
                            DEFAULT_ROOT_URL + 'signed-out',
                            DEFAULT_ROOT_URL + 'fr/signed-out',
                            DEFAULT_ROOT_URL + 'please-verify-your-email-address',
                            DEFAULT_ROOT_URL + 'fr/please-verify-your-email-address',
                            DEFAULT_ROOT_URL + 'sign-in-to-account',
                            DEFAULT_ROOT_URL + 'fr/sign-in-to-account',
                            DEFAULT_ROOT_URL + 'create-an-account',
                            DEFAULT_ROOT_URL + 'fr/create-an-account',
                            DEFAULT_ROOT_URL + 'browser-not-compatible',
                            DEFAULT_ROOT_URL + 'fr/browser-not-compatible',
                            DEFAULT_ROOT_URL + 'please-verify-your-email-address',
                            DEFAULT_ROOT_URL + 'fr/please-verify-your-email-address',
                          ];

    public isBrowserCompatible:boolean = false;
    public isApiUnavailable:boolean = false;
    public renderIndex: number = 1;

    public languageId: number = 1;

    created(){
      this.languageId = authService.getLocaleFromUrl() == "en" ? 1 : 2;

      this.isBrowserCompatible = browserDetector.isSupported();
      if(!this.isBrowserCompatible) {
        if (window.location.pathname != '/browser-not-compatible') {
          this.redirectToUrl('browser-not-compatible')
        }
      }
    }


    public mounted() {
      this.languageId = authService.getLocaleFromUrl() == "en" ? 1 : 2;

      this.getLabels();

      authService.authenticationHandler();

      // To avoid page reload in Drupal and for better user experience, we must call this function twice.
      this.getYuDrivUserFromApi();
    }

    public getYuDrivUserFromApi(){
        authService.getUser()
        .then((user:any) => {
          if(user) {
            if(user.profile.email_verified) {
              this.isAuthorized = authService.isAuthorized();

              if(this.isAuthorized) {
                this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                // get ols user and default client
                authService.getOlsUserFromApi().then(() => {
                  let pOlsUser = sessionStorage.getItem('olsUser')

                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    // if olsuser is not active, bring dialog with info and logout user
                    if(olsUser.isActive){
                      this.initYuDrivUser(olsUser);
                    } else {
                      if (olsUser.olsUserId > 0) {  // this check is here for users that are  missing data returned from VIVVO, CASE: 12595. Show dialog only if user data is returned from API.
                        this.olsUserNotActiveDialog.isOpen = true;
                        setTimeout(() => {
                          this.logout();
                        }, 3000)
                      }
                    }
                  }
                });

              }
              else {
                sessionStorage.removeItem('access_denied');
                this.logout();
              }
            }
            else {
              // if email is not verified
              sessionStorage.setItem('access_denied', "true");
            }
          }
        })
        .catch(error => console.log(error))
        .finally(() => {

          if(!this.isAuthorized) {
            this.redirectionHandler();
          }

          if(window.location.href.indexOf("/sign-in-required") > -1 && this.isAuthorized) {
            this.redirectToUrl(DEFAULT_ROOT_URL);
          }

           // if email is not verified
          var access_denied = sessionStorage.getItem('access_denied');
          if(access_denied){
            if(access_denied === "true") {
              this.redirectionHandler();
            }
          }

          this.loader.loading = false;
          this.loader.loaded = true;
          
        });
    }

    public initYuDrivUser(olsUser:any) {
      let pOlsUser = sessionStorage.getItem('olsUser')
      let user = pOlsUser ? JSON.parse(pOlsUser) : "";

      axios
        .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true', {
          headers:{
            "Authorization": "Bearer " + user.accessToken // This is added manually only because of first login redirect from IDP since function promise is not returning token properly.
          }
        })
          .then(response => {
            this.clientData = response.data;
            axios.get('client/getcartviewmodel/' + olsUser.olsUserId + '/' + this.clientData.clientId, {
              headers:{
                "Authorization": "Bearer " + user.accessToken // This is added manually only because of first login redirect from IDP since function promise is not returning token properly.
              }
            })
            .then(response => {
              this.shoppingCartData = response.data;
            })
            .catch(error => console.log(error))
            .finally(() => {

              this.loader.loading = false;
              this.loader.loaded = true;

              if (this.isAuthorized) {
                if (this.clientData.clientId === 0 && !document.URL.includes("profile-manager") && !this.clientData.isActive) {
                  this.redirectToUrl(this.authLabels.ProfileManagerUrl);
                } else {
                  return;
                }
              }
            });
        })
        .catch(error => console.log(error))
    }

    public logout() {
      let pOlsUser = sessionStorage.getItem('olsUser');
      if(pOlsUser) { this.currentOlsUser = JSON.parse(pOlsUser); }

      const postObj = {
        isOnline: true,
        clientId: this.clientData.clientId,
        olsUserId: this.currentOlsUser.olsUserId
      }

      axios.post('security/logout', postObj).then(() => {
        // cart is clear with sp security.Logout
      });

      authService.logout();
    }

    public menuItems = [
      {
        title: 'Services',
        active: false,
        items: [] as any[]
      }
    ]

    public retryIfApiUnavailable: number = 0;

    public getLabels(){
        axios.get('olsUserProfile/getAuthenticationLabels')
            .then(response => {
              this.authLabels = JSON.parse(JSON.stringify(response.data));

              this.menuItems[0].title = this.authLabels.Services;

              this.menuItems[0].items.push({ "title": this.authLabels.AbstractTitle, "url": this.authLabels.AbstractUrl});
              this.menuItems[0].items.push({ "title": this.authLabels.RegistrationRenewTitle, "url": this.authLabels.RegistrationRenewUrl})
              this.menuItems[0].items.push({ "title": this.authLabels.NewSingleTripPermitTitle, "url": this.authLabels.NewSingleTripPermitUrl})
              this.menuItems[0].items.push({ "title": this.authLabels.NewMultiTripPermitTitle, "url": this.authLabels.NewMultiTripPermitUrl})
              this.menuItems[0].items.push({ "title": this.authLabels.PendingApplicationTitle, "url": this.authLabels.PendingApplicationUrl})
              this.menuItems[0].items.push({ "title": this.authLabels.SearchDocumentsTitle, "url": this.authLabels.SearchDocumentsUrl})
              this.menuItems[0].items.push({ "title": this.authLabels.ScheduleExamTitle, "url": this.authLabels.ScheduleExamUrl})

            })
            .catch(error => {
              // DISABLE AUTH BUTTONS IF CONNECTION TO API IS LOST OR UNAVAILABLE
              if (!error.response) {
                  // network error
                  if(this.retryIfApiUnavailable < 4){
                    this.getLabels();
                    this.retryIfApiUnavailable++
                  }else{
                    this.isApiUnavailable = true;
                    console.error('Error: Network Error. Please contact network administrator for more details.');
                  }
              } else {
                  console.log(error.response.data.message);
              }
            })
    }

    redirectionHandler() {
      // if user is redirected from auth0 with access_denied url parameter in url
      if(window.location.href.indexOf("#error=access_denied") > -1) {

        sessionStorage.setItem('access_denied', 'true');
        let ad = sessionStorage.getItem('access_denied');

        if (ad) {
          if (ad === "true") {
            window.location.href = '/please-verify-your-email-address'
            sessionStorage.removeItem('access_denied');
          }
        }
      }

      //if user is redirected from auth0 after sign in but email is not verified
      let ad = sessionStorage.getItem('access_denied');
      if (ad) {
        if (ad === "true") {
          window.location.href = '/please-verify-your-email-address'
          sessionStorage.clear();
        }
      }

      //if you're logged out when trying to access any module, you will be redirected to login page
      if (this.doNotRedirectUrls.indexOf(window.location.pathname) < 0) {
        this.redirectToUrl('sign-in-to-account');
      }
    }

    redirectToUrl(url: string) {
      if (this.languageId == 2 ) {
        return window.location.href = DEFAULT_ROOT_URL_FR + url;//DEFAULT_ROOT_URL_FR + url;  
      }
      return window.location.href = DEFAULT_ROOT_URL + url;
    }
  }

